import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './components/LoginPage';
import MobileDemo from './components/mobile/MobileDemo';
import { Box, CircularProgress } from '@mui/material';
import './App.css';

const AppContent = () => {
  const { isAuthenticated, login, loading } = useAuth();

  // Mobile container wrapper component
  const MobileContainer = ({ children }) => (
    <Box sx={{
      width: '100%',
      maxWidth: '425px', // iPhone 14 Pro Max width
      minHeight: '100vh',
      backgroundColor: 'white',
      margin: '0 auto',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {children}
    </Box>
  );

  if (loading) {
    return (
      <MobileContainer>
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
          <CircularProgress size={60} sx={{ color: 'white' }} />
        </Box>
      </MobileContainer>
    );
  }

  if (!isAuthenticated) {
    return (
      <MobileContainer>
        <LoginPage onLogin={login} />
      </MobileContainer>
    );
  }

  return (
    <MobileContainer>
      <div className="App" style={{ width: '100%', height: '100%' }}>
        <MobileDemo />
      </div>
    </MobileContainer>
  );
};

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Provider>
  );
}

export default App;